import { Button, Confirm, ConfirmProps } from 'semantic-ui-react'
import { AxiosError } from 'axios'
import * as React from 'react'

import { useToasts } from '../toasts/ToastsProvider'
import { useApi } from '../../store/mainContext'
import { Recipe } from '../../types'

interface Props extends ConfirmProps {
  recipeId: Recipe['_id']
}

export default function ConfirmDeleteRecipeDialog(props: Props) {
  const { recipeId, onSuccess, ...other } = props

  const { addToast } = useToasts()
  const api = useApi()

  const [isPending, setIsPending] = React.useState(false)

  const handleConfirm = () => {
    setIsPending(true)
    return api
      .delete('recipes/' + recipeId)
      .then(onSuccess)
      .then(() => addToast('Recipe deleted', { variant: 'success' }))
      .catch((e: AxiosError) => {
        addToast(e.response?.data.message || e.message, { variant: 'danger' })
      })
      .finally(() => setIsPending(false))
  }

  return (
    <Confirm
      header="Are you sure?"
      content={
        <div className="px-6 pb-4">
          <p className="text-base">This action will:</p>
          <ul className="list-disc space-y-2 pl-6 text-lg">
            <li>Delete the selected Recipe.</li>
            <li>Delete all the schedulled runs for this recipe.</li>
          </ul>
          <p className="mt-4 text-base font-semibold">
            This action cannot be undone.
          </p>
        </div>
      }
      closeOnDimmerClick={!isPending}
      closeOnEscape={!isPending}
      size="tiny"
      onConfirm={handleConfirm}
      cancelButton={<Button disabled={isPending} content="Cancel" />}
      confirmButton={
        <Button
          disabled={isPending}
          primary={false}
          color="red"
          loading={isPending}
        >
          Yes, delete the Recipe
        </Button>
      }
      {...other}
    />
  )
}
